import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import endpoints from './endpoints/index.endpoints';
import { CampaignConfigAuditSourceOption, ConfigChangeEvent } from '../models/campaign-config-audit.model';

export type FetchCampaignConfigChangesParams = {
	sources: string;
	from?: string;
	to?: string;
	limit?: number;
	searchFilter?: string;
	action_type?: number;
	scope_value?: string;
	campaign_phase_id?: number;
};

export function fetchCampaignConfigAuditSourceOptions(): Promise<CampaignConfigAuditSourceOption[]> {
	return ask.get(endpoints.campaignConfigAudit.sourcesOptions());
}

export function fetchCampaignConfigChanges(params: FetchCampaignConfigChangesParams, searchFilter: string): Promise<ConfigChangeEvent[]> {
	const paramsToSend = new URLSearchParams();

	paramsToSend.set('sources', params.sources);
	if (params.from) {
		paramsToSend.set('from', params.from);
	}
	if (params.to) {
		paramsToSend.set('to', params.to);
	}
	if (params.limit !== undefined) {
		paramsToSend.set('limit', String(params.limit));
	}
	if (searchFilter) {
		paramsToSend.set('search_filter', searchFilter);
	}
	if (params.action_type !== undefined) {
		paramsToSend.set('action_type', String(params.action_type));
	}
	if (params.scope_value !== undefined) {
		paramsToSend.set('scope_value', String(params.scope_value));
	}
	if (params.campaign_phase_id !== undefined) {
		paramsToSend.set('campaign_phase_id', String(params.campaign_phase_id));
	}
	return ask.get(endpoints.campaignConfigAudit.changes(), paramsToSend);
}
